import type { Query } from "@tanstack/react-query";

/**
 * True only for the **merchant orders table** list query shape used by `useOrders`:
 * `queryKey: ["orders", params]` where `params` is a plain object (`GetOrdersParams`).
 *
 * **Not matched** (so they are not invalidated by create/update mutations):
 * - `["orders", "stores"]`, `["orders", "locations", …]`, `["orders", "merchants"]`, …
 * - `["sysops", "orders", …]`
 *
 * If you add another `["orders", <object>]` query that is **not** the main list, either
 * use a different first key segment or extend this predicate to exclude it explicitly.
 */
export function isOrdersTableListQuery(query: Query): boolean {
  const k = query.queryKey;
  return (
    Array.isArray(k) &&
    k[0] === "orders" &&
    k.length >= 2 &&
    typeof k[1] === "object" &&
    k[1] !== null &&
    !Array.isArray(k[1])
  );
}
